import type { ApiClient } from '../../api/client';
import type { FeatureRelease, FeatureReleaseAccess, FeatureReleaseHistoryItem, FeatureReleasePort, FeatureReleaseUser } from '../../features/feature-release/public';

export function createFeatureReleaseHttpAdapter(client: ApiClient): FeatureReleasePort {
  const root = '/api/hr/v1/{tenant}/feature-releases';
  const collection = async <T>(path: string) => (await client.requestTenant<{ data: T[] }>(path)).data;
  return {
    list: () => collection<FeatureRelease>(root),
    update: async (key, input) => (await client.requestTenant<{ data: FeatureRelease }>(`${root}/${encodeURIComponent(key)}`, { method: 'PUT', body: JSON.stringify(input) })).data,
    history: (key) => collection<FeatureReleaseHistoryItem>(`${root}/${encodeURIComponent(key)}/history`),
    searchUsers: (search) => collection<FeatureReleaseUser>(`${root}/users?${new URLSearchParams({ search })}`),
    userAccess: (personId) => collection<FeatureReleaseAccess>(`${root}/users/${encodeURIComponent(personId)}/access`),
  };
}
